import { CgPlayButton } from "react-icons/cg";
import "./btnPlay.scss";

const BtnPlay = () => {
  return <CgPlayButton className="btn-big-play" />;
};

export default BtnPlay;
